import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { withNamespaces } from 'react-i18next';
import i18next from 'i18next';

import { analytics } from 'core/analytics';
import {
  MainWrapper,
  Center,
  Divider,
  Overlay,
} from 'legacyComponents/styled/lib';
import { html } from 'libs/editor/serializers/html';
import { EditorStore } from 'libs/editor/store';
import { Editor } from 'libs/editor';

import { modalStore } from 'apps/modals/app';
import { StoryWrapper, Title, Article, CoverImage } from 'apps/story/styles';
import { CardSection } from 'legacyComponents/layout/cardSection';
import { ProjectCard } from 'legacyComponents/cards/types/project';
import { StoryCard } from 'legacyComponents/cards/types/story';
import { ThreadCard } from 'legacyComponents/cards/types/thread';
import { CollectionCard } from 'legacyComponents/cards/types/collection';
import { CollectionForm } from 'apps/collection/collectionForm/index';
import { BottomStickyWrapper, CtaButton } from 'apps/home/landing/styles';

import { imageSrc } from 'apps/file/utils';
import { conf as mainConf } from 'apps/config.yaml';
import { conf } from 'apps/channel/config.yaml';

import Twix from 'components/Twix';
import Sticky from 'components/Sticky';

@withNamespaces()
@inject('clientStore')
@observer
export class ChannelLanding extends React.Component {
  onClickCTA = cta => {
    if (cta.disabled) return;
    const { clientStore } = this.props;
    const eventName = `clicked-landing-${cta.name}`;
    analytics.sendEvent(eventName);
    if (cta.navigation) {
      const navigationParams = cta.navigation.params || {};
      clientStore.routerStore.navigate(cta.navigation.route, navigationParams);
    }
  };

  buttonsCTA = () => {
    const {
      appManager: { channel },
    } = this.props;

    if (!channel?.CTAs?.length) return null;
    const buttonsList = channel.CTAs.map((cta, i) => (
      <CtaButton
        key={i}
        onClick={() => this.onClickCTA(cta)}
        text={cta.text}
        disabled={!!cta.disabled}
      />
    ));

    return (
      <Twix>
        <Sticky>
          <Center>{buttonsList}</Center>
        </Sticky>
        <BottomStickyWrapper>
          <Center>{buttonsList}</Center>
        </BottomStickyWrapper>
      </Twix>
    );
  };

  render() {
    const { appManager, clientStore } = this.props;
    const {
      channel,
      threadsConn,
      projectsConn,
      storiesConn,
      collectionsConn,
    } = appManager;
    const { story } = channel;
    const { avatar, title, body } = story;
    const { t } = i18next;

    const src = imageSrc(
      avatar,
      story.imageFallbackPath,
      mainConf.imgSizes.story.large,
    );
    const coverImageSection = src ? [<CoverImage src={src} key='image' />] : '';

    const store = new EditorStore({
      initialValue: html.deserialize(body || '<p></p>'),
      formatting: 'advanced',
    });

    const threads = threadsConn.arrayApp;
    const projects = projectsConn.arrayApp;
    const stories = storiesConn.arrayApp;
    const collections = collectionsConn.arrayApp;

    const channelContentBuilder = () => {
      const OverlayTag = channel ? Overlay : 'div';
      const overlayProps = channel
        ? { active: channel.editing, onClick: this.goToTop }
        : {};

      return (
        <OverlayTag {...overlayProps}>
          {channel.sections.includes('projects') && (
            <CardSection
              title={t(conf.sections[0])}
              tooltip={t('Create new project')}
              updateHeader={true}
              index={1}
              createHandler={() =>
                clientStore.routerStore.navigate('home.newProject')
              }
              isChannel={true}
              ownerName=''
              cardApp={projects}
              CardComponent={ProjectCard}
              noDataCardType='project'
              gridColumns={3}
            />
          )}
          {channel.sections.includes('stories') && (
            <CardSection
              title={t(conf.sections[2])}
              tooltip={t('Create new story')}
              updateHeader={true}
              index={2}
              createHandler={() =>
                clientStore.routerStore.navigate('home.newStory')
              }
              isChannel={true}
              ownerName=''
              cardApp={stories}
              CardComponent={StoryCard}
              noDataCardType='story'
              gridColumns={2}
            />
          )}
          {channel.sections.includes('threads') && (
            <CardSection
              title={t('Threads')}
              subTitle={' '}
              updateHeader={true}
              index={0}
              isChannel={true}
              ownerName=''
              cardApp={threads}
              CardComponent={ThreadCard}
              noDataCardType='forumThreads'
            />
          )}
          {channel.sections.includes('collections') && (
            <CardSection
              title={t('Collections')}
              tooltip={t('Create new collection')}
              updateHeader={true}
              index={3}
              createHandler={() => modalStore.SetModalComponent(CollectionForm)}
              isChannel={true}
              ownerName=''
              cardApp={collections}
              CardComponent={CollectionCard}
              noDataCardType='collection'
              gridColumns={3}
            />
          )}
        </OverlayTag>
      );
    };

    const channelContent = channel?.sections?.length && channelContentBuilder();

    return (
      <>
        <MainWrapper marginBottom='40px'>
          {coverImageSection}
          <Article>
            <Title>{title}</Title>
            <StoryWrapper margin='40px auto 0 auto'>
              <Editor store={store} />
            </StoryWrapper>
            <Divider width='100%' margin='20px auto 40px auto' />
          </Article>
          {this.buttonsCTA()}
          {channelContent}
        </MainWrapper>
      </>
    );
  }
}

ChannelLanding.propTypes = {
  appManager: PropTypes.object,
  params: PropTypes.object,
  clientStore: PropTypes.object,
};
